import { Injectable } from '@angular/core';
import { BFF_URL } from '../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BehaviorSubject, take } from 'rxjs';
import { IUserMdn, USER_MDNS } from '../interfaces/account';
import { PendingPlansResponse } from '../interfaces/pending-plans';

@Injectable({
    providedIn: 'root'
})
export class AccountService {

    public mdns = new BehaviorSubject<IUserMdn[] | null>(null);

    constructor(private http: HttpClient) { }

    getUserAccount(mdn: string): Promise<any> {
        const headers = new HttpHeaders({
            'content-type': 'application/json'
        });
        return new Promise<any>((resolve, reject) => {
            this.http.get<any>(`${BFF_URL}/v1/ca/account/${mdn}`, { headers })
                .pipe(take(1))
                .subscribe({
                    next: (result) => resolve(result),
                    error: (error) => reject(error)
                });
        });
    }

    addActivatedMdn(mdn: string): Promise<{ planId: string }> {
        const headers = new HttpHeaders({
            'content-type': 'application/json'
        });

        return new Promise<{ planId: string }>((resolve, reject) => {
            this.http.post<{ planId: string }>(`${BFF_URL}/v1/ca/account/add-activated-mdn`, { mdn }, { headers })
                .pipe(take(1))
                .subscribe({
                    next: (result) => resolve(result),
                    error: (error) => reject(error)
                });
        });
    }

    validatePhoneNumber(mdn: string): Promise<any> {
        const headers = new HttpHeaders({
            'content-type': 'application/json'
        });
        return new Promise<any>((resolve, reject) => {
            this.http.get<any>(`${BFF_URL}/v1/ca/account/${mdn}/validate`, { headers })
                .pipe(take(1))
                .subscribe({
                    next: (result) => resolve(result),
                    error: (error) => reject(error)
                });
        });
    }

    isPhoneNumberExists(mdn: string): Promise<any> {
        const headers = new HttpHeaders({
            'content-type': 'application/json'
        });
        return new Promise<any>((resolve, reject) => {
            this.http.get<any>(`${BFF_URL}/v1/ca/account/${mdn}/exists`, { headers })
                .pipe(take(1))
                .subscribe({
                    next: (result) => resolve(result),
                    error: (error) => reject(error)
                });
        });
    }

    getUserMdns(): Promise<USER_MDNS> {
        const headers = new HttpHeaders({
            'content-type': 'application/json'
        });
        return new Promise<USER_MDNS>((resolve, reject) => {
            this.http.get<USER_MDNS>(`${BFF_URL}/v1/ca/account/mdns`, { headers })
                .pipe(take(1))
                .subscribe({
                    next: (result) => {
                        this.mdns.next(result?.mdns ?? []);
                        resolve(result);
                    },
                    error: (error) => reject(error)
                });
        });
    }

    clearMdnsCache(): void {
        this.mdns.next(null);
    }

    validateMdn(mdn: string): Promise<any> {
        const headers = new HttpHeaders({
            'content-type': 'application/json'
        });
        return new Promise<any>((resolve, reject) => {
            this.http.get<any>(`${BFF_URL}/v1/ca/account/mdn/${mdn}/validate`, { headers })
                .pipe(take(1))
                .subscribe({
                    next: (result) => resolve(result),
                    error: (error) => reject(error)
                });
        });
    }

    changePlan(mdn: string, bundleId: string, bundleAction: string = 'ADD'): Promise<any> {
        const headers = new HttpHeaders({
            'content-type': 'application/json'
        });
        return new Promise<any>((resolve, reject) => {
            this.http.post<any>(`${BFF_URL}/v1/ca/account/${mdn}/bundles`, { bundleId, bundleAction }, { headers })
                .pipe(take(1))
                .subscribe({
                    next: (result) => resolve(result),
                    error: (error) => reject(error)
                });
        });
    }

    getPendingActivations(): Promise<PendingPlansResponse> {
        const headers = new HttpHeaders({
            'content-type': 'application/json'
        });
        return new Promise<PendingPlansResponse>((resolve, reject) => {
            this.http.get<PendingPlansResponse>(`${BFF_URL}/v1/ca/account/pending-plans`, { headers })
                .pipe(take(1))
                .subscribe({
                    next: (result) => resolve(result ?? {}),
                    error: (error) => reject(error)
                });
        });
    }
    getPendingPlanById(id: string): Promise<PendingPlansResponse> {
        const headers = new HttpHeaders({
            'content-type': 'application/json'
        });
        return new Promise<PendingPlansResponse>((resolve, reject) => {
            this.http.get<PendingPlansResponse>(`${BFF_URL}/v1/ca/account/pending-plans/${id}`, { headers })
                .pipe(take(1))
                .subscribe({
                    next: (result) => resolve(result ?? {}),
                    error: (error) => reject(error)
                });
        });
    }
    submitPort(body):  Promise<any> {
        const headers = new HttpHeaders({
            'content-type': 'application/json'
        });
        const jsonBody = JSON.stringify(body);
        return new Promise<any>((resolve, reject) => {
            this.http.post<any>(`${BFF_URL}/v1/ca/account/port-in`, jsonBody, { headers })
                .pipe(take(1))
                .subscribe({
                    next: (result) => resolve(result),
                    error: (error) => reject(error)
                });
        });
    }
    updatePlanProvince(billingProvince, mdn):  Promise<any> {
        const headers = new HttpHeaders({
            'content-type': 'application/json'
        });
        return new Promise<any>((resolve, reject) => {
            this.http.put<any>(`${BFF_URL}/v1/ca/account/plans/${mdn}/billing-province`, {billingProvince}, { headers })
                .pipe(take(1))
                .subscribe({
                    next: (result) => resolve(result),
                    error: (error) => reject(error)
                });
        });
    }
    
}
